import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { aircraftId: Number }

  selectPoint(event) {
    const group = event.currentTarget
    const sessionId = group.dataset.sessionId
    if (!sessionId) return

    // Highlight selected point
    this.element.querySelectorAll("g.weight-point").forEach(g => {
      g.classList.remove("weight-point-selected")
    })
    group.classList.add("weight-point-selected")

    // Load CG envelope via Turbo Frame
    const frame = document.getElementById("cg_envelope")
    if (frame) {
      frame.src = `/aircrafts/${this.aircraftIdValue}/cg_envelope?session_id=${sessionId}`
    }
  }
}
